import CompanyLinksContainer from './components/CompanyLinksContainer';

export default CompanyLinksContainer;
